<template>
    <v-row>
        <v-col cols="3">
            <v-select
                dense
                v-model="store.formInfo.format"
                :items='formats'
                item-value='id'
                item-text='value'
                :label='$t("format")'
            ></v-select>
        </v-col>
    </v-row>
</template>

<script>
export default {
    inject: ['store'],
    data() {
        return {
            bank: 'lib'
        }
    },
    created() {
        this.store.formInfo.format = this.formats[0].id
    },
    computed: {
        formats() {
            return [
                {
                    id: 'xls',
                    value: '行內批量轉帳範本 (XLS)'
                },
            ]
        },
    },
    methods:{

    },

}
</script>
<style>
    .hsbcfield{
        font-size: 14px;
        padding: 0px;
    }
    .hsbcfield input{
        padding:3px 0px;
    }
    .hsbcfield .v-label{
        font-size: 14px !important;
    }
    .hsbcfield .v-label--active{
        font-size: 16px !important;
    }
</style>